import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["master", "checkbox", "count", "action", "selection"]

    connect() {
        this.reset = this.resetSelection.bind(this)
        this.submitStart = event => {
            if (this.actionTargets.includes(event.detail.formSubmission.submitter)) this.setPending(true)
        }
        this.submitEnd = () => { this.setPending(false); this.resetSelection() }
        this.guardSubmit = event => { if (this.pending) event.preventDefault() }
        document.addEventListener("turbo:before-cache", this.reset)
        document.addEventListener("turbo:before-visit", this.reset)
        this.element.addEventListener("turbo:submit-start", this.submitStart)
        this.element.addEventListener("turbo:submit-end", this.submitEnd)
        this.element.addEventListener("submit", this.guardSubmit)
        this.resetSelection()
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", this.reset)
        document.removeEventListener("turbo:before-visit", this.reset)
        this.element.removeEventListener("turbo:submit-start", this.submitStart)
        this.element.removeEventListener("turbo:submit-end", this.submitEnd)
        this.element.removeEventListener("submit", this.guardSubmit)
    }

    checkboxTargetConnected(checkbox) {
        checkbox.checked = false
        this.updateAfterToggle()
    }

    checkboxTargetDisconnected() {
        this.updateAfterToggle()
    }

    resetSelection() {
        this.checkboxTargets.forEach(cb => cb.checked = false)
        this.updateAfterToggle()
    }

    setPending(pending) {
        this.pending = pending
        this.element.setAttribute("aria-busy", String(pending))
        this.updateAfterToggle()
    }

    toggleAll(event) {
        if (this.pending) return this.updateAfterToggle()
        const checked = event.currentTarget.checked
        this.availableCheckboxTargets.forEach(cb => cb.checked = checked)
        this.updateAfterToggle()
    }

    toggleOne() {
        this.updateAfterToggle()
    }

    updateAfterToggle() {
        const total = this.availableCheckboxTargets.length
        const count = this.selectedIds().length
        if (this.hasMasterTarget) {
            this.masterTarget.checked = total > 0 && count === total
            this.masterTarget.indeterminate = count > 0 && count < total
            this.masterTarget.disabled = total === 0 || !!this.pending
        }
        this.countTargets.forEach(target => target.textContent = count > 0 ? `(${count} selected)` : "")
        this.actionTargets.forEach(button => button.disabled = count === 0 || !!this.pending)
        this.selectionTargets.forEach(target => {
            target.hidden = count === 0
            target.classList.toggle("d-none", count === 0)
        })
    }

    selectedIds() {
        return [...new Set(this.availableCheckboxTargets.filter(cb => cb.checked).map(cb => cb.value))]
    }

    openSelected(event) {
        event.preventDefault()
        if (this.pending || !this.selectedIds().length) return
        const url = new URL(event.currentTarget.dataset.bulkUrl, window.location.origin)
        if (url.origin !== window.location.origin) return
        this.selectedIds().forEach(id => url.searchParams.append(`${event.currentTarget.dataset.bulkIdsKey || "ids"}[]`, id))
        window.open(url.toString(), "_blank", "noopener")
    }

    get availableCheckboxTargets() {
        return this.checkboxTargets.filter(cb => !cb.disabled)
    }
}
